import { render, staticRenderFns } from "./CourseManagement.vue?vue&type=template&id=664f6502&scoped=true"
import script from "./CourseManagement.vue?vue&type=script&lang=js"
export * from "./CourseManagement.vue?vue&type=script&lang=js"
import style0 from "./CourseManagement.vue?vue&type=style&index=0&id=664f6502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664f6502",
  null
  
)

export default component.exports